export default __webpack_public_path__ + "static/media/15.6422c112.jpg";